import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Label, Input, FormFeedback, FormGroup } from 'reactstrap'
import { Field } from 'formik'
import _ from 'lodash'

export default class FormikRadioInputField extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.string,
    inputName: PropTypes.string.isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
  }

  render() {
    const props = this.props
    const error = _.get(props.errors, props.inputName)
    const isInvalid = error && _.get(props.touched, props.inputName)
    return (
      <Wrapper>
        <Label className="pt-2 pr-2">
          <Field
            checked={props.values[props.name] === props.inputName}
            className="mr-2"
            name={props.name}
            type="radio"
            value={props.value}
          />
          {props.label}
        </Label>
        <FormGroup>
          <Input
            disabled={props.disabled || props.isSubmitting}
            id={props.id}
            invalid={isInvalid}
            name={props.inputName}
            readOnly={props.readOnly}
            tag={Field}
            type={props.type}
            validate={props.validate}
          />
          <FormFeedback>{error}</FormFeedback>
        </FormGroup>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  display: flex;
`



// WEBPACK FOOTER //
// ./src/components/FormikRadioInputField.js